import Select from "react-select";
import useDidMount from "../../hooks/useDidMount";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {tryFetchCitiesAndAreas} from "../../redux/slices/addressSlice";
import {isEmpty} from "lodash";

export const LocationSelector = React.memo(({
                                              parent,
                                              location,
                                              disabled,
                                              className = "",
                                              setLocation,
                                              isCity,
                                              error,
                                              preserveErrorSpace = true,
                                              isParentEmpty = false
                                            }) => {

  const type = isCity ? "cities" : "areas";

  const {[parent?.id ?? ""]: locationData} = useSelector((state) => state.address[type])

  const {init, loading, data: locations} = locationData ?? {
    loading: false, data: [],
    init: false, error: ""
  };

  const dispatch = useDispatch();

  useDidMount(() => {
    if (!init && parent?.id) {
      dispatch(tryFetchCitiesAndAreas({type, parentId: parent.id}))
    }

  }, [parent, init])


  const valid = (isParentEmpty && !loading && isEmpty(locations)) || (!isParentEmpty && !loading && !isEmpty(locations))
    || (!isParentEmpty && loading && isEmpty(locations))


  return (
    <div className={className}>
      <label className="ml-3">{isCity ? 'City' : 'Area'} *</label>
      <Select instanceId={type} placeholder={`Select ${isCity ? 'City' : 'Area'}`}
        isLoading={loading}
        value={location}
        isDisabled={disabled}
        noOptionsMessage={() => parent?.id ? 'No options' : isCity ? 'Please, Select province first' : 'Please, Select city first'}
        options={locations}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        onChange={(option) => {
          setLocation(option)
        }}
        />
      {
        (!valid || error) ? <div
            className='text-xs text-error-500 ml-4 pt-2'>{error ? error : `${isCity ? "City" : "Area"} not available in selected ${isCity ? "province" : "city"}`}</div> :
          (preserveErrorSpace ? <div className="h-[5px]"/> : "")
      }
    </div>
)
})